import { FC } from 'react';
import { DashboardWidget, useDashboardWidget } from '@frontend/grid-dashboard';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { useTooltip } from '@frontend/design-system';
import { isWidgetWidthSmall } from '../../../utils/widgets';
import { ProgressSwitcher } from './progress-switcher';
import { infoIconContainer, dashboardHeader, progressSwitcherWrapper, dashboardHeaderContainer } from './styles';
import { TimeRangeSelector } from './time-range-selector';

export const WidgetHeader: FC = () => {
  const { t } = useTranslation('task-center');
  const { Tooltip, triggerProps, tooltipProps } = useTooltip({ placement: 'bottom' });
  const { currentBreakpoint, isEditMode, currentSize } = useDashboardWidget();

  const isWidthSmall = isWidgetWidthSmall(currentBreakpoint, currentSize);

  return (
    <DashboardWidget.Header css={[dashboardHeaderContainer, !isEditMode && dashboardHeader]}>
      <span
        {...triggerProps}
        css={infoIconContainer}
        tabIndex={0}
        aria-label={t('Only tasks assigned to you are visible here')}
      >
        <Icon name='info-small' />
      </span>
      <Tooltip {...tooltipProps}>{t('Only tasks assigned to you are visible here')}</Tooltip>
      <div css={progressSwitcherWrapper(isWidthSmall)}>
        <ProgressSwitcher />
      </div>
      <TimeRangeSelector isWidthSmall={isWidthSmall} />
    </DashboardWidget.Header>
  );
};
